// require('bootstrap/transition');
// require('bootstrap/tab');
// require('bootstrap/tooltip');
require('bootstrap/collapse');
// require('bootstrap/dropdown');
require('bootstrap/modal');
// require('jquery-ui/ui/position');
// require('jquery-ui/ui/keycode');
// require('jquery-ui/ui/unique-id');
// require('jquery-ui/ui/widget');
// require('jquery-ui/ui/widgets/menu');

require('jquery-ui/ui/widgets/autocomplete');
// require('jquery-ui/ui/widgets/datepicker');
require('bootstrap-responsive-tabs/src/jquery.bootstrap-responsive-tabs');

// import 'imports?jQuery=jquery!owl.carousel/dist/owl.carousel';
// import 'owl.carousel';
// import 'components/faq';